
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 26 26"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#50585B","stroke-width":"1.1","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M16.156 18.75c-3.748 0-6.787-1.044-6.787-5.743 0-4.698 3.039-5.742 6.787-5.742M7.803 13.53h5.743m-5.743-2.093h6.787"}}),_c('path',{attrs:{"d":"M23.304 10.951c1.926-1.254.685-4.264-1.57-3.786 1.301-1.892-.995-4.202-2.897-2.9.478-2.246-2.533-3.497-3.787-1.568-.422-2.261-3.679-2.264-4.1 0C9.7.773 6.688 2.008 7.165 4.266c-1.897-1.3-4.202 1-2.898 2.9C2.021 6.687.764 9.69 2.697 10.95c-2.257.419-2.268 3.673 0 4.098-1.924 1.252-.69 4.265 1.57 3.788-1.3 1.892.992 4.203 2.897 2.9-.475 2.244 2.53 3.5 3.787 1.566.42 2.262 3.677 2.264 4.099 0 1.25 1.924 4.264.69 3.787-1.568 1.894 1.302 4.201-1 2.897-2.898 2.255.475 3.497-2.535 1.57-3.788 2.254-.417 2.269-3.677 0-4.098z"}})])])
          )
        }
      }
    